<template>
  <div class="player">

    <div class="player-infosong">
      <div class="player-header text-left pt-3 pl-3 pr-3">
        <h1 class="color-white font-weight-bold font-size-20">{{ song }} - <span class="color-blue">{{ singer }}</span></h1>
        <p class="color-white"><span class="color-blue">Nhạc sĩ: </span>{{ author }}</p>
        <p class="color-white"><span class="color-blue">Thể loại: </span>Nhạc Trẻ</p>
      </div>

      <div class="player-footer pb-3">
        <div class="button">
          <a class="text-uppercase color-white"
             @click="showModal(giftAlert.replace('songcode', code))">
            <span class="fa fa-gift color-white font-size-22 pl-2 pr-2"></span>
            Quà tặng âm nhạc
          </a>
        </div>

        <div class="button">
          <a class="text-uppercase color-white"
             @click="ringbacktone != '' ? showModal(downloadAlert.replace('songcode', ringbacktone)) : showModal(settings.installRingbacktoneAlert)">
            <span class="fa fa-tablet color-white font-size-18 pl-2 pr-2"></span>
            Nhạc chờ
          </a>
        </div>

        <div class="button">
          <a class="text-uppercase color-white" :href="filepath" download>
            <span class="fa fa-download color-white font-size-18 pl-2 pr-2"></span>
            Tải về
          </a>
        </div>

        <div class="button">
          <a target="_blank"
             :href="shareFacebookUrl"
             class="text-uppercase color-white fb-xfbml-parse-ignore">
            <span class="fa fa-facebook-square color-white font-size-18 pl-2 pr-2"></span>
            Chia sẻ
          </a>
        </div>
        <div class="parent expand" style="clear: both"></div>
      </div>

      <div class="playerdetail text-left" id="playerdetail"></div>
    </div>
    <div class="lyrics text-left position-relative">
      <div class="songname pt-3 pb-3">
        <span class="font-size-20">Lời bài hát: </span>
        <span class="font-size-22 color-blue font-weight-bold">{{ song }}</span>
        <span> - </span>
        <span class="font-size-20">{{ singer }}</span>
      </div>

      <a href="#show" class="show" id="show">Xem toàn bộ <span class="fa fa-angle-double-down"></span></a>
      <a href="#hide" class="hide" id="hide">Thu gọn <span class="fa fa-angle-double-up"></span></a>
      <div class="lyric-content text-justify" v-html="lyric"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Player",
    props: {

    },
    data () {
      return {
        song: "",
        singer: "",
        author: "Đang cập nhật",
        category: "",
        lyric: "",
        code: "",
        ringbacktone: "",
        filepath: "",
        dataAlbum: [
          /*{
            name: 'Cung đàn vỡ đôi',
            artist: 'Chi Pu',
            url: 'http://localhost:8787/dmz/UploadFiles/20200615/_CungDanVoDoi-ChiPu.mp3',
            cover: 'http://localhost:8787/dmz//UploadFiles/20200615//_chipu.jpg',
            lrc: 'Lời bài hát cung đàn vỡ đôi<br/>Lời bài hát cung đàn vỡ đôi<br/>Lời bài hát cung đàn vỡ đôi<br/>'
          },

          {
            name: 'Cung đàn vỡ đôi 2',
            artist: 'Chi Pu 2',
            url: 'http://localhost:8787/dmz/UploadFiles/20200615/_CungDanVoDoi-ChiPu.mp3',
            cover: 'http://localhost:8787/dmz//UploadFiles/20200615//_chipu.jpg',
            lrc: 'Lời bài hát cung đàn vỡ đôi 2'
          }*/
        ],
        giftAlert: this.settings.giftAlert,
        downloadAlert: this.settings.downloadAlert,
        shareFacebookUrl: "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href + "&amp;src=sdkpreparse",
        defaultThumbnailSong: this.settings.defaultThumbnailSong
      }
    },
    mounted () {
      var self = this;

      /*//Khởi tạo player
      const ap = new APlayer({
        container: document.getElementById('playerdetail'),
        audio: this.dataAlbum,
        autoplay: true
      });

      //Lấy thông tin bài hát
      ap.on("play", function () {
        var thisAudio = ap.audio;
        self.song = thisAudio.getAttribute("data-song");
        self.singer = thisAudio.getAttribute("data-singer");
        self.lyric = thisAudio.getAttribute("data-lyrics");
        console.log(thisAudio);
      });*/

      //Ẩn nút xem toàn bộ lời bài hát
      setTimeout(() => {
        if($(".lyric-content").height() < 200){
          $(".show").hide();
        }
      }, 1000)
    },
    methods: {
      getAlbum(){
        axios.post(api.albumDetail, {code: this.$route.params.code})
          .then(response => {
            var res = response.data.result;
            res.forEach(item => {
              this.dataAlbum.push(
                {
                  name: item.song,
                  artist: item.singer,
                  url: item.filepath,
                  cover: item.thumbnail != "" ? item.thumbnail : this.defaultThumbnailSong,
                  lrc: item.lyrics,
                  id: item.musician,
                  code: item.code,
                  ringbacktone: item.RingBackTone
                }
              );
            });
            return this.dataAlbum;
          })
          .then(response => {
            var self = this;

            //Khởi tạo player
            const ap = new APlayer({
              container: document.getElementById('playerdetail'),
              audio: response,
              autoplay: true
            });

            //Lấy thông tin bài hát
            ap.on("play", function () {
              var thisAudio = ap.audio;
              self.song = thisAudio.getAttribute("data-song");
              self.singer = thisAudio.getAttribute("data-singer");
              self.lyric = thisAudio.getAttribute("data-lyrics");
              self.code = thisAudio.getAttribute("data-code");
              self.ringbacktone = thisAudio.getAttribute("data-ringbacktone");
              self.author = thisAudio.getAttribute("data-id") != "" ? thisAudio.getAttribute("data-id") : "Đang cập nhật";
              self.filepath = thisAudio.getAttribute("src");
              //console.log(thisAudio);

              setTimeout(() => {
                if($(".lyric-content").height() < 200){
                  $(".show").hide();
                } else {
                  $(".show").show();
                }
              }, 0)
            });
          })
          .catch(e => {
            console.log("Chi tiết album----");
            console.log(e);
          });
      },
      showModal(message){
        this.$emit("modalMessage", message);
        this.modalShow();
      }
    },
    watch:{
      "$route.params.code": {
        handler: "getAlbum",
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .player-infosong{
    min-height: 100px;
    background-color: #001f46;
    padding-bottom: 0.02rem;
  }
  .playerdetail{
    color: #d0d0d0;
    background-color: #32477c;
  }

  .player-footer .button{
    width: fit-content;
    float: left;
    border: 1px solid #32477c;
    margin: 0 1rem;
    border-radius: 30px;
    padding: 0.2rem 0.5rem;
  }
  .lyric-content {
    position: relative;
    max-height: 200px;
    overflow: hidden;
    -webkit-transition: max-height .5s ease;
    transition: max-height .5s ease;
  }
  .show, .hide {
    position: absolute;
    bottom: -1.5em;
    z-index: 100;
    text-align: center;
  }
  .hide {
    display: none;
  }
  .show:target {
    display: none;
  }
  .show:target ~ .hide {
    display: block;
  }
  .show:target ~ .lyric-content {
    max-height: 2000px;
  }
</style>



// WEBPACK FOOTER //
// src/components/albumplay/web/Player.vue